export const routes = [
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "public": true
    }
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'bookstores',
        name: '/admin/bookstores',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/admin/bookstores.vue'),
        /* no children */
        meta: {
          "layout": "bare"
        }
      },
      {
        path: 'edges',
        /* internal name: '/admin/edges' */
        /* no component */
        children: [
          {
            path: 'progress',
            name: '/admin/edges/progress',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/admin/edges/progress.vue'),
            /* no children */
            meta: {
              "layout": "bare"
            }
          }
        ],
      },
      {
        path: 'generate-sprites',
        name: '/admin/generate-sprites',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/admin/generate-sprites.vue'),
        /* no children */
        meta: {
          "layout": "bare"
        }
      },
      {
        path: 'presentation-text',
        /* internal name: '/admin/presentation-text' */
        /* no component */
        children: [
          {
            path: ':decision',
            name: '/admin/presentation-text/[decision]',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/admin/presentation-text/[decision].vue'),
            /* no children */
            meta: {
              "layout": "bare"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/bookcase',
    /* internal name: '/bookcase' */
    /* no component */
    children: [
      {
        path: ':all(.*)',
        name: '/bookcase/[...all]',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/bookcase/[...all].vue'),
        /* no children */
      },
      {
        path: 'afficher',
        /* internal name: '/bookcase/afficher' */
        /* no component */
        children: [
          {
            path: ':username',
            name: '/bookcase/afficher/[username]',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/bookcase/afficher/[username].vue'),
            /* no children */
            meta: {
              "public": true
            }
          }
        ],
      },
      {
        path: 'contributors',
        name: '/bookcase/contributors',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/bookcase/contributors.vue'),
        alias: ["/bibliotheque/contributeurs"],
        /* no children */
      },
      {
        path: 'options',
        name: '/bookcase/options',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/bookcase/options.vue'),
        alias: ["/bibliotheque/options"],
        /* no children */
      },
      {
        path: 'show',
        /* internal name: '/bookcase/show' */
        /* no component */
        children: [
          {
            path: ':username',
            name: '/bookcase/show/[username]',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/bookcase/show/[username].vue'),
            /* no children */
            meta: {
              "public": true
            }
          }
        ],
      }
    ],
  },
  {
    path: '/bookstores',
    /* internal name: '/bookstores' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bookstores/',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/bookstores/index.vue'),
        alias: ["/bouquineries"],
        /* no children */
        meta: {
          "public": true
        }
      }
    ],
  },
  {
    path: '/collection',
    /* internal name: '/collection' */
    /* no component */
    children: [
      {
        path: 'account',
        name: '/collection/account',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/account.vue'),
        alias: ["/collection/compte"],
        /* no children */
      },
      {
        path: 'afficher',
        /* internal name: '/collection/afficher' */
        /* no component */
        children: [
          {
            path: ':all(.*)',
            name: '/collection/afficher/[...all]',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/afficher/[...all].vue'),
            alias: ["/collection/afficher"],
            /* no children */
          }
        ],
      },
      {
        path: 'duplicates',
        name: '/collection/duplicates',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/duplicates.vue'),
        alias: ["/collection/doubles"],
        /* no children */
      },
      {
        path: 'on-sale',
        name: '/collection/on-sale',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/on-sale.vue'),
        alias: ["/collection/a-lire"],
        /* no children */
      },
      {
        path: 'show',
        /* internal name: '/collection/show' */
        /* no component */
        children: [
          {
            path: ':all(.*)',
            name: '/collection/show/[...all]',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/show/[...all].vue'),
            alias: ["/collection","/collection/show"],
            /* no children */
          },
          {
            path: 'new',
            name: '/collection/show/new',
            component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/show/new.vue'),
            alias: ["/collection/afficher/new"],
            /* no children */
          }
        ],
      },
      {
        path: 'subscriptions',
        name: '/collection/subscriptions',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/subscriptions.vue'),
        alias: ["/collection/abonnements"],
        /* no children */
      },
      {
        path: 'to-read',
        name: '/collection/to-read',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/to-read.vue'),
        alias: ["/collection/a-lire"],
        /* no children */
      },
      {
        path: 'user',
        /* internal name: '/collection/user' */
        /* no component */
        children: [
          {
            path: ':username',
            /* internal name: '/collection/user/[username]' */
            /* no component */
            children: [
              {
                path: ':all(.*)?',
                name: '/collection/user/[username]/[[...all]]',
                component: () => import('/home/runner/work/core/core/apps/web/src/pages/collection/user/[username]/[[...all]].vue'),
                alias: ["/collection/user/:username"],
                /* no children */
                meta: {
                  "public": true
                }
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/demo',
    name: '/demo',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/demo.vue'),
    /* no children */
    meta: {
      "public": true
    }
  },
  {
    path: '/expand',
    /* internal name: '/expand' */
    /* no component */
    children: [
      {
        path: 'marketplace',
        name: '/expand/marketplace',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/expand/marketplace.vue'),
        alias: ["/agrandir/marketplace"],
        /* no children */
      },
      {
        path: 'suggestions',
        name: '/expand/suggestions',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/expand/suggestions.vue'),
        alias: ["/agrandir/suggestions","/agrandir","/expand"],
        /* no children */
      }
    ],
  },
  {
    path: '/forgot',
    /* internal name: '/forgot' */
    /* no component */
    children: [
      {
        path: '',
        name: '/forgot/',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/forgot/index.vue'),
        /* no children */
        meta: {
          "public": true
        }
      },
      {
        path: ':token',
        name: '/forgot/[token]',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/forgot/[token].vue'),
        /* no children */
        meta: {
          "public": true
        }
      }
    ],
  },
  {
    path: '/image-search-test',
    name: '/image-search-test',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/image-search-test.vue'),
    /* no children */
    meta: {
      "layout": "bare",
      "public": true
    }
  },
  {
    path: '/inducks-import',
    name: '/inducks-import',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/inducks-import.vue'),
    /* no children */
    meta: {
      "public": true
    }
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/login.vue'),
    alias: ["/connexion"],
    /* no children */
    meta: {
      "public": true
    }
  },
  {
    path: '/print',
    /* internal name: '/print' */
    /* no component */
    children: [
      {
        path: '',
        name: '/print/',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/print/index.vue'),
        alias: ["/impression"],
        /* no children */
      },
      {
        path: 'classic',
        name: '/print/classic',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/print/classic.vue'),
        alias: ["/impression/classique"],
        /* no children */
        meta: {
          "layout": "bare"
        }
      },
      {
        path: 'collectable',
        name: '/print/collectable',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/print/collectable.vue'),
        alias: ["/impression/collectable"],
        /* no children */
        meta: {
          "layout": "bare"
        }
      }
    ],
  },
  {
    path: '/privacy',
    name: '/privacy',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/privacy.vue'),
    /* no children */
    meta: {
      "layout": "bare",
      "public": true
    }
  },
  {
    path: '/signup',
    name: '/signup',
    component: () => import('/home/runner/work/core/core/apps/web/src/pages/signup.vue'),
    alias: ["/inscription"],
    /* no children */
    meta: {
      "public": true
    }
  },
  {
    path: '/stats',
    /* internal name: '/stats' */
    /* no component */
    children: [
      {
        path: 'authors',
        name: '/stats/authors',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/stats/authors.vue'),
        alias: ["/auteurs"],
        /* no children */
      },
      {
        path: 'conditions',
        name: '/stats/conditions',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/stats/conditions.vue'),
        /* no children */
      },
      {
        path: 'general',
        name: '/stats/general',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/stats/general.vue'),
        alias: ["/stats"],
        /* no children */
      },
      {
        path: 'possessions',
        name: '/stats/possessions',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/stats/possessions.vue'),
        /* no children */
      },
      {
        path: 'publications',
        name: '/stats/publications',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/stats/publications.vue'),
        /* no children */
      },
      {
        path: 'purchases',
        name: '/stats/purchases',
        component: () => import('/home/runner/work/core/core/apps/web/src/pages/stats/purchases.vue'),
        alias: ["/achats"],
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

